<!-- Top Panel - Dialog Name/Type and Recipients List -->
<div class="row">

	<!-- Dialog Name/Type -->
	<div style="padding-left: 16px; padding-bottom: 8px" class="col-sm-6">
		<div class="col-sm-12">
			DIALOG NAME
			<input [(ngModel)]="mDialog.name" type="text" class="form-control input-lg">
		</div>
		<div class="col-sm-12">
			DIALOG TYPE
			<input [(ngModel)]="mDialog.type" type="text" class="form-control input-lg">
		</div>
	</div>
	
	<!-- Recipients List -->
	<div class="col-sm-6" style="width: calc(50% - 16px)">
		RECIPIENTS: 
		<span>
			<ul style="list-style-type: none; padding-left: 0px; max-height: 120px; overflow-y: auto; overflow-x: hidden;">
				<ng-container *ngIf="mDialog.groups == null || mDialog.groups.length == 0">
					<li>
						NONE
					</li>
				</ng-container>
				<ng-container *ngIf="mDialog.groups != null && mDialog.groups.length > 0">
					<li *ngFor="let group of mDialog.groups">
						{{group.name}}
					</li>
				</ng-container>
			</ul>
		</span>
	</div>
</div>

<!-- Dialog Display -->
<div class="panel panel-danger">
	
	<!-- Dialog Title  -->
	<div class="modal-header modal-header-danger">
		<span class="glyphicon glyphicon-alert"></span>
		{{mTestTimestamp | date:"MMM d, y h:mm:ss a" | uppercase}} - {{ mDialog.type | uppercase}}
		<div class="pull-right">
			<span style="cursor: pointer">X</span>
		</div>
	</div>
	
	<!-- Dialog Body -->
	<div class="modal-body-danger">
		<div class="container-fluid bd-example-row" style="margin-bottom: 0px;">
		
			<!-- Message (Top Level) -->
			<div *ngIf="mDialog.message != null" class="row" style="color: #000000">
				<app-dialog-message-editor
					[mDialog]="this.mDialog"
					[mUniqueIndex]="this.mUniqueIndex"
					[event]="this.mEvent"
					>
				</app-dialog-message-editor>
			</div>
			
			<!-- Main Body -->
			<div class="row" style="height: 100%">
			
				<!-- Left Hand Side (Alert Info / Checklist / Comments) -->
				<div class="col-md-7">
					
					<!-- Alert Info Pane -->
					<!-- Picture -->
					<div class="col-sm-4" style="padding: 5px; margin: 0;">
						<div class="well-danger">
							<img src="assets/images/userDefault.png" class="img-responsive">
							<button type="button" class="btn btn-danger btn btn-block">
								<i class="fa fa-phone" aria-hidden="true"></i>
								CONTACT
							</button>
						</div>
					</div>
					<!-- Info -->
					<div class="col-sm-8" style="padding: 5px; margin: 0;">
						<div class="list-group">
							<a class="list-group-item-alert">
								<p class="list-group-item-text">
									<strong><i class="fa fa-user"></i> ALERT FROM:</strong>
								</p>
							</a>
							<a class="list-group-item-alert">
								<p class="list-group-item-text">
									<strong><i class="fa fa-exclamation"></i> ALERT TYPE:</strong>
								</p>
							</a>
							<a class="list-group-item-alert">
								<p class="list-group-item-text">
									<strong><i class="fa fa-calendar"></i> DATE & TIME:</strong>
								</p>
							</a>
							<a class="list-group-item-alert">
								<p class="list-group-item-text">
									<strong><i class="fa fa-map"></i> LOCATION:</strong>
								</p>
							</a>
							<a class="list-group-item-alert">
								<p class="list-group-item-text">
									<strong><i class="fa fa-map-marker"></i> ZONE:</strong>
								</p>
							</a>
						</div>
					</div>
					
					<!-- Checklist / Comments -->
					<div class="col-sm-12" style="padding: 5px;margin: 0">
						<!-- Checklist Header -->
						<div *ngIf="mDialog.items != null"  class="tab">
							<div class="pull-right" style="margin: 10px;">
								<a style="color: #bc0000">
									<i class="fa fa-info-circle" aria-hidden="true"></i>
								</a>
							</div>
							
							<button class="tablinks">
								<i class="fa fa-check" aria-hidden="true"></i>
								{{mDialog.itemsHeader}}
							</button>
						</div>
						
						<!-- Checklist Items -->
						<div *ngIf="mDialog.items != null" class="tabcontent" style="max-height: 200px; overflow-y: auto; overflow-x: hidden;">
							<ul class="alert">
								<li *ngFor="let item of mDialog.items">
									{{item.label}}
								</li>
							</ul>					
						</div>
					
						<!-- Comments -->
						<div *ngIf="mDialog.showComment" class="panel panel-danger">
							<div class="panel-heading">
								<h1 class="panel-title" style="font-size: 18px;  padding: 8px;">
									{{mDialog.messageHeader}}
								</h1>
							</div>
							<div class="panel-body" style="background-color:#fafafa; margin: 0; padding: 0; max-height: 200px">
								<textarea class="form-control" rows="5" style="color: #000000; background-color: #d9d9d9" disabled="disabled"></textarea>
							</div>
						</div>
					</div>
				</div>
				
				<!-- Right Hand Side / Map -->
				<div *ngIf="mDialog.showMap" class="col-sm-5" style="height: 100%;">
					<div align="center" ng-hide="map" class="well-danger" style="height: 430px; color: #929292; padding-top: 50%">
						<i class="fa fa-map fa-5x" aria-hidden="true"></i>
						<br>
						MAP OF INCIDENT
					</div>
				</div>
			</div>
		
		</div>
	</div>
		
	<!-- Buttons -->
	<div *ngIf="mDialog.buttons != null && mDialog.buttons.length > 0" (click)="selectButton.emit(null)" class="modal-footer-danger" style="height: 70px">
		<div style="float: right; position: relative; margin: 5px" *ngFor="let button of mDialog.buttons">
			<button type="button" (click)="selectButton.emit(button); $event.stopPropagation()" (mouseenter)="onMouseEnter(button)" (mouseleave)="onMouseLeave(button)" [ngClass]="getClassForButton(button)" [style.border]="button == mSelectedButton? '6px solid black' : '0px'">
				
				<i *ngIf="isMouseOver(button) && isOwnerButton(button)" style="display: inline-block;" class="fa fa-check"></i>
				<i *ngIf="isMouseOver(button) && isCloseButton(button)" style="display: inline-block;" class="fa fa-close"></i>
				<i *ngIf="isMouseOver(button) && isDeclineButton(button)" style="display: inline-block;" class="fa fa-exclamation-circle"></i>
				<i *ngIf="isMouseOver(button) && isWaitButton(button)" style="display: inline-block;" class="fa fa-hourglass-2"></i>
				
				{{button.label}}
			
				<!-- Remove -->
				<div (click)="removeButtonClicked(button); $event.stopPropagation()" *ngIf="isMouseOver(button)" style="position: absolute; bottom: 20px; right: 0px; background: red; border: 1px solid red; border-radius: 10px; color: white; display: block;">
					<i class="fa fa-close"></i>
				</div>
				
				<!-- Move Right -->
				<div (click)="moveButtonRightClicked(button); $event.stopPropagation()" *ngIf="isMouseOver(button) && button.order != 1" style="position: absolute; bottom: 0px; right: 0px; background: blue; border: 1px solid blue; border-radius: 10px; color: white; display: block;">
					<i class="fa fa-arrow-right"></i>
				</div>
				
				<!-- Move Left -->
				<div (click)="moveButtonLeftClicked(button); $event.stopPropagation()" *ngIf="isMouseOver(button) && button.order != mDialog.buttons.length" style="position: absolute; bottom: 0px; left: 0px; background: blue; border: 1px solid blue; border-radius: 10px; color: white; display: block;">
					<i class="fa fa-arrow-left"></i>
				</div>
			</button>
		</div>
	</div>
	
</div>